import React from 'react'
import { color, Icon } from '@manychat/manyui'

import { HelperIconProps } from './types'

export const HelperIcon = ({ text }: HelperIconProps) => {
  return (
    <Icon.Question size={16} color={color.icon.subtle} data-title={text} data-title-width={160} />
  )
}
